module.exports = __webpack_public_path__ + "img/kns-logo.9c797bf9.svg";